import React from 'react';
import Modal from 'react-modal';
import closeIcon from '../../assets/images/close-icon.svg';
import './index.scss';

export interface IAppModal {
  isOpen: boolean;
  onClose: (e: any) => void;
  hideCloseIcon?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  children?: React.ReactNode;
  adjustToContent?: boolean;
}

const AppModal = ({
  isOpen,
  onClose,
  size = 'md',
  children,
  hideCloseIcon = false,
  adjustToContent = false
}: IAppModal) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName={`modalOverlay`}
      className={`modalContent ${size}${adjustToContent ? ' adjust-to-content' : ''}`}
    >
      {!hideCloseIcon && (
        <button
          type="button"
          aria-label="Close"
          className="tw-absolute tw-top-0 tw-right-0 tw-z-10 tw-cursor-pointer tw-inline-flex tw-items-center tw-justify-center tw-w-11 tw-h-11 tw-bg-transparent tw-border-0 tw-p-0"
          onClick={onClose}
        >
          <img src={closeIcon} alt="" className="tw-w-6" />
        </button>
      )}
      {children}
    </Modal>
  );
};

export default AppModal;
